export function matchMediaAddEventListener(mq, callback, eventBubbling = false) {
    try {
        mq.addEventListener('change', callback, eventBubbling);
        // eslint-disable-next-line no-unused-vars
    }
    catch (e) {
        mq.addListener(() => callback);
    }
}
export function matchMediaRemoveEventListener(mq, callback) {
    try {
        mq.removeEventListener('change', callback);
        // eslint-disable-next-line no-unused-vars
    }
    catch (e) {
        mq.removeListener(() => callback);
    }
}
